import { useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { shareRevisionRequest } from './request.share.js';

function useShareRevisionMutation() {
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(shareRevisionMutation(notifier, user));
}
const shareRevisionMutation = (notifier, user) => {
  return {
    mutationKey: ["course-revision/share", user?.id],
    mutationFn: async input => await shareRevisionRequest(user, input.revision, input.userIds, input.teamIds),
    onSuccess: () => {
      notifier.notify({
        id: "course-revisions.share",
        type: "success",
        body: "Versionen er blevet delt"
      });
    },
    onError: () => {
      notifier.notify({
        id: "course-revisions.share.error",
        type: "error",
        body: "Versionen kunne ikke deles, prøv igen om lidt."
      });
    }
  };
};

export { useShareRevisionMutation };
//# sourceMappingURL=mutation.share.js.map
